export enum SubscriptionPlan {
  EssentialMonthly = "essential-monthly",
  EssentialAnnual = "essential-annual",
  AdvancedMonthly = "advanced-monthly",
  AdvancedAnnual = "advanced-annual",
}

export enum PlanFeature {
  Source = "source",
  ProModel = "pro-model",
}

export const DEFAULT_PLAN = SubscriptionPlan.EssentialMonthly;

export const PLAN_VALUES: string[] = Object.values(SubscriptionPlan);

export const ADVANCED_PLANS: SubscriptionPlan[] = [
  SubscriptionPlan.AdvancedMonthly,
  SubscriptionPlan.AdvancedAnnual,
];

export const ESSENTIAL_PLANS: SubscriptionPlan[] = [
  SubscriptionPlan.EssentialMonthly,
  SubscriptionPlan.EssentialAnnual,
];

export const FEATURE_AVAILABILITY_MAP: Record<PlanFeature, SubscriptionPlan[]> = {
  [PlanFeature.Source]: ADVANCED_PLANS,
  [PlanFeature.ProModel]: ADVANCED_PLANS,
};